import { Expose } from "class-transformer";

export class UpdatePlanningBoardProjectNoteDto {
  @Expose()
  planningBoardProjectId: string;

  @Expose()
  notes?: string | null;
}
